import { gql } from '@apollo/client';

export const APPLY_REQUEST = gql`
  mutation applyRequest($comment: String) {
    applyRequest(input: { comment: $comment }) {
      request {
        id
        employee {
          id
          status
        }
      }
    }
  }
`;
